export const ART_PLACEHOLDER_MOBILE_URL = 'https://heygirl.cutestperson.com/assets/public/art-placeholder-mobile.png' as const;
